import { AfterViewInit, Component, Input } from '@angular/core';
import { MaskedDateCellEditorBaseComponent } from '../masked-date-cell-editor-base/masked-date-cell-editor-base.component';

/**
 * Inline DateTime/Date/Time Input Custom Editor
 */
@Component({
    selector: 'se-masked-date-cell-editor-inline',
    templateUrl: './masked-date-cell-editor-inline.component.html',
    styleUrls: ['./masked-date-cell-editor-inline.component.scss']
})
export class MaskedDateCellEditorInlineComponent extends MaskedDateCellEditorBaseComponent implements AfterViewInit {

    /**
     * If doing fullRow edit, this is true if the cell is the one that started the edit
     * otherwise this is always true
     */
    @Input() startEdited: boolean;

    constructor() {
        super();
    }

    ngAfterViewInit(): void {
        if (this.startEdited) {
            this.formReady.emit(this.formControl);
            window.setTimeout(() => {
                this.dateInput.nativeElement.focus();
                this.dateInput.nativeElement.select();
            }, 0);
        }
    }

}
